import type { Resource } from '../../';
export const product_sizeChart_category_littleKids: Resource = {"default":"Little Kids"};
